import { ChangeEvent, useState } from 'react';

import { LocationIcon, DownArrowIcon, UpArrowIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import SearchBarSearchInput from '@components/ui/search/SearchBarInput/SearchBarSearchInput/SearchBarSearchInput';
import { SearchViewModel } from '@api/v3';
import { useSearchHook } from '@components/views/hooks/useSearchBar';
import { SEARCH_LENGTH } from '@utils/utils';
import { useDebounceValue } from '@hooks/hooks';

import DestinationSearchResultList from './DestinationSearchResultList';
import { Wrapper } from './style';

interface DestinationSearchProps {
  searchText?: string;
  onSearchTextChange: (s: string) => void;
  onDestinationChange: (d: SearchViewModel) => void;
  placeholder?: string;
  type?: 'hotel' | 'tour' | 'ship';
  tourStyle?: boolean;
  tourListing?: boolean;
  borderRadius?: string;
}

const DestinationSearch = ({
  searchText = '',
  onSearchTextChange,
  onDestinationChange,
  placeholder,
  type = 'hotel',
  tourStyle,
  tourListing,
  borderRadius,
}: DestinationSearchProps) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const debounceLocation = useDebounceValue<string>(searchText);
  const { data, isError } = useSearchHook(
    type,
    debounceLocation,
    isOverlayOpen
  );

  return (
    <Wrapper>
      <SearchBarSearchInput
        tourListing={tourListing}
        tourStyle={tourStyle}
        label='Nereye Gideceksiniz?'
        inputProps={{
          onChange: (event: ChangeEvent<HTMLInputElement>) => {
            onSearchTextChange(event.target.value);
          },
          onFocus: () => setIsOverlayOpen(true),

          value: searchText,
          placeholder,
        }}
        popoverProps={{
          onClickOutside: () => setIsOverlayOpen(false),
        }}
        isFilled={(searchText && searchText.length > 0) || false}
        SearchResultListComponent={({ onChange }) =>
          searchText.length >= SEARCH_LENGTH ? (
            <DestinationSearchResultList
              onSelect={(item: SearchViewModel) => {
                onChange(item.text);
                onDestinationChange(item);
                setIsOverlayOpen(false);
              }}
              data={data || []}
              isError={isError}
            />
          ) : null
        }
        leftIcon={() => (
          <CustomIcon
            fontSize={28}
            paletteColor='coral'
            icon={LocationIcon}
            clickable
            onClick={() => setIsOverlayOpen((val) => !val)}
          />
        )}
        rightIcon={() => (
          <CustomIcon
            icon={isOverlayOpen ? UpArrowIcon : DownArrowIcon}
            fontSize={16}
            paletteColor='darkGray'
            clickable
            onClick={() => setIsOverlayOpen((val) => !val)}
          />
        )}
        borderRadius={borderRadius}
      />
    </Wrapper>
  );
};

export default DestinationSearch;
